<template>
  <article class="text-dark">
    <SubscriptionLoading v-if="isloading" :is-loading="isloading" />
    <header class="header-top">
      <h4 class="text-danger col-xxs-12 d-xs-12 pb-xxs-0">
        {{ $t('register.title') }}
      </h4>
    </header>
    <section class="px-3">
      <b-form-group>
        <div class="d-flex justify-content-between pt-sm-1">
          <label for="cellOrEmail">
            {{ $t(inputType.cellOrEmailLabel) }}
          </label>
        </div>

        <b-form-input
          id="cellOrEmail"
          v-model.trim="model.uuId"
          v-validate="{ required: true,regex: inputType.regex }"
          name="cellOrEmail"
          class="dir-ltr mb-md-0 mb-2"
          :type="inputType.type"
          :placeholder="$t(inputType.cellOrEmailPlaceholder)"
          :data-vv-as="$t(inputType.cellOrEmailLabel)"
          :state="validationState('cellOrEmail')"
          aria-describedby="cellOrEmail"
          autofocus
          @blur.native="checkUniqueUUID()"
        />
        <b-form-invalid-feedback id="cellOrEmail">
          <ul class="list-unstyled px-0">
            <li
              v-if="!errors.has('cellOrEmail') && cellOrEmailAsyncValidationMessage"
            >
              {{ cellOrEmailAsyncValidationMessage }}
            </li>
            <li v-for="error in errors.collect('cellOrEmail')" :key="error">
              {{ error }}
            </li>
          </ul>
        </b-form-invalid-feedback>

        <b-link
          class="d-xxs-inline d-md-none text-decoration-none"
          href="#"
          @click="toggleInputType()"
        >
          {{ $t(inputType.registerType) }}
        </b-link>
      </b-form-group>
      <b-form-group>
        <label for="password">
          {{ $t('register.password') }}
        </label>
          <b-input-group>
            <template v-slot:append>
              <b-button variant="light" class="pt-2 rounded-right show-password" :class="{'icon-eye':!isPasswordVisible,'icon-eye-slash':isPasswordVisible}" @click="togglePassword"/>
            </template>
            <b-form-input
               id="password"
               ref="password"
              v-model.trim="model.password"
              v-validate="{ required: true, regex: /.{6,}$/ }"
              :type="passwordFieldType"
              placeholder="********"
              class="dir-ltr"
              name="password"
              data-vv-as="register.password"
              :state="validationState('password')"
              aria-describedby="password"
            />
            <b-form-invalid-feedback id="password">
             {{ errors.first('password') }}
            </b-form-invalid-feedback>
          </b-input-group>
      </b-form-group>

      <!--<b-form-group>-->
        <!--<label for="confirmPassword">-->
          <!--{{ $t('register.confirmPassword') }}-->
        <!--</label>-->
        <!--<b-form-input-->
          <!--id="confirmPassword"-->
          <!--v-model.trim="model.confirmPassword"-->
          <!--v-validate="{required:true, regex: /.{6,}$/ ,confirmed:'password'}"-->
          <!--type="password"-->
          <!--placeholder="********"-->
          <!--class="dir-ltr"-->
          <!--name="confirmPassword"-->
          <!--:state="validationState('confirmPassword')"-->
          <!--aria-describedby="confirmPassword"-->
          <!--data-vv-as="register.password"-->
        <!--/>-->
        <!--<b-form-invalid-feedback id="confirmPassword">-->
          <!--{{ errors.first('confirmPassword') }}-->
        <!--</b-form-invalid-feedback>-->
      <!--</b-form-group>-->
      <section class="d-flex flex-xxs-column flex-sm-row justify-content-between align-items-center
        mt-xs-5">
        <div class="d-flex align-self-md-center align-self-xxs-start mt-2"><b-form-checkbox
        class="align-self-center"
          id="agreeWithTermsAndConditions"
          v-model="model.agreeWithTermsAndConditions"
        />
        <h6
          v-html="$t('register.agreeWithTermsAndConditions',{termsAndConditions:$t('register.termsAndConditions')})"
        />
        </div>
          <b-button
        size="lg"
        class="submit col-sm-4 col-xxs-12 py-2 mt-sm-0 mt-xxs-2"
        variant="success"
        :disabled="(!model.agreeWithTermsAndConditions)"
        @click="registerUser"
      >
        {{ $t("register.registerButton") }}
      </b-button>
        </section>
    </section>
    <ErrorBox v-if="serverError" :error-message="serverError" />
  </article>
</template>

<script>
import SubscriptionLoading from '@/components/SubscriptionLoading.vue'
import windowSize from '@/mixins/window-size.js'
import { mapActions, mapGetters } from 'vuex'
import ContentPlaceholders from '@/components/ContentPlaceholders.vue'
import ContentPlaceholdersHeading from '@/components/ContentPlaceholdersHeading.vue'
import ContentPlaceholdersText from '@/components/ContentPlaceholdersText.vue'
import ErrorBox from '@/components/ErrorBox.vue'

export default {
  name: 'RegisterForm',
  components: {
    SubscriptionLoading,
    ContentPlaceholders,
    ContentPlaceholdersHeading,
    ContentPlaceholdersText,
    ErrorBox
  },
  mixins: [windowSize],
  computed: {
    ...mapGetters({
      isPinCodeSent: 'registration/isPinCodeSent'
    })
  },
  data () {
    return {
      cellOrEmailAsyncValidationMessage: null,
      usernameAsyncValidationMessage: null,
      serverError: null,
      isloading: false,
      agreeWithTermsAndConditions: false,
      isActiveKeyboard: false,
      inputType: {
        cellOrEmailLabel: '',
        cellOrEmailPlaceholder: '',
        type: 'text',
        registerType: '',
        regex: /(?:(\d{10,13})|(([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})))$/
      },

      model: {
        uuId: '',
        cell: '',
        email: '',
        userName: '',
        password: '',
        confirmPassword: '',
        deviceType: '',
        isEmail: ''
      },
      isPasswordVisible: false,
      passwordFieldType: 'password'
    }
  },
  methods: {
    ...mapActions({
      register: 'registration/register',
      setRouteName: 'order/setRouteName',
      checkUsernameExist: 'registration/checkUsernameExist',
      checkNicknameExist: 'registration/checkNicknameExist'
    }),
    validationState (ref) {
      if (
        this.fields[ref] &&
        this.fields[ref].dirty &&
        (this.errors.has(ref) ||
          this.cellOrEmailAsyncValidationMessage ||
          this.usernameAsyncValidationMessage)
      ) {
        return false
      } else if (
        this.fields[ref] &&
        this.fields[ref].dirty &&
        !(
          this.errors.has(ref) ||
          this.cellOrEmailAsyncValidationMessage ||
          this.usernameAsyncValidationMessage
        )
      ) {
        return true
      } else if (
        this.fields[ref] &&
        (!this.fields[ref].dirty && this.errors.has(ref))
      ) {
        return false
      }
      return null
    },
    registerUser () {
      this.$validator.validateAll().then(valid => {
        if (
          !valid ||
          this.usernameAsyncValidationMessage ||
          this.cellOrEmailAsyncValidationMessage
        ) {
          return
        }

        this.isloading = true
        this.serverError = null

        this.register(this.model)
          .then(response => {
            this.isloading = false
            if (this.isPinCodeSent) {
              this.setRouteName('register')
              this.setOtpActivationQueryStringType()
            } else {
              this.serverError = this.$t('validations.messages.server_error')
            }
          })
          .catch(error => {
            this.isloading = false
            this.serverError = this.$t('validations.messages.server_error')
          })
      })
    },
    setOtpActivationQueryStringType () {
      if (this.isEmail()) {
        this.isMaxWidth768()
          ? this.redirect('sendotpactivation', 'email')
          : this.redirect('sendactivationlink', 'email')
      } else if (this.isMobile()) {
        this.redirect('sendotpactivation', 'cell')
      }
    },
    redirect (pathName, type) {
      this.$router.push({
        path: pathName,
        query: { type: type }
      })
    },

    initializeForm () {
      this.isMaxWidth768()
        ? this.setInputTypeToCell()
        : this.setInputTypeToEmail()
      // this.setInputTypeToCell()
    },
    setInputTypeToCell () {
      this.inputType.cellOrEmailLabel = 'register.cell'
      this.inputType.cellOrEmailPlaceholder = 'register.cellPlaceholder'
      this.inputType.type = 'tel'
      this.inputType.registerType = 'register.registerByEmail'
      this.model.deviceType = 'Mobile'
      this.model.isEmail = false
      this.inputType.regex = /\d{10,13}$/
    },
    setInputTypeToEmail () {
      this.inputType.cellOrEmailPlaceholder = 'register.emailPlaceholder'
      this.inputType.registerType = 'register.registerByCell'
      this.model.isEmail = true
      if (this.isDesktop()) {
        this.inputType.cellOrEmailLabel = 'register.cellOrEmail'
        this.inputType.type = 'text'
        this.model.deviceType = 'Desktop'
        this.inputType.regex = /(?:(\d{10,13})|(([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})))$/
      } else {
        this.inputType.cellOrEmailLabel = 'register.email'
        this.inputType.type = 'email'
        this.model.deviceType = 'Mobile'
        this.inputType.regex = /([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/
      }
    },
    toggleInputType () {
      this.model.uuId = ''
      this.isActiveLinkCellular()
        ? this.setInputTypeToCell()
        : this.setInputTypeToEmail()
     // this.setInputTypeToCell()
    },
    isMobile () {
      var mobileRegexp = /(\+98|0)?9\d{9}/
      return mobileRegexp.test(this.model.uuId)
    },
    isEmail () {
      var emailRegexp = /([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})/
      return emailRegexp.test(this.model.uuId)
    },
    isActiveLinkCellular () {
      if (this.inputType.registerType.indexOf('registerByCell') > -1) {
        return true
      }
      return false
    },
    changeWindowSize () {
      // window.addEventListener("resize", this.initializeForm);
    },
    checkUniqueUUID () {
      this.cellOrEmailAsyncValidationMessage = null
      if (this.model.uuId && !this.errors.has('cellOrEmail')) {
        this.checkUsernameExist({
          username: this.model.uuId,
          suggestNickname: true
        })
          .then(response => {
            if (response.body.result.isDuplicated) {
              this.cellOrEmailAsyncValidationMessage = this.$t(
                'validations.messages.repeated',
                { fieldName: this.$t(this.inputType.cellOrEmailLabel) }
              )
            } else {
              if (!this.model.userName) {
                this.model.userName = response.body.result.suggestedNickname
              }
            }
          })
          .catch(error => {
            this.cellOrEmailAsyncValidationMessage = this.$t(
              'validations.messages.repeated_server_error',
              { fieldName: this.$t(this.inputType.cellOrEmailLabel) }
            )
          })
      }
    },
    checkUniqueUsername () {
      this.usernameAsyncValidationMessage = null
      if (this.model.userName && !this.errors.has('username')) {
        this.checkNicknameExist({
          nickname: this.model.userName
        })
          .then(response => {
            if (response.body.result) {
              this.usernameAsyncValidationMessage = this.$t(
                'validations.messages.repeated',
                { fieldName: this.$t('register.username') }
              )
            }
          })
          .catch(error => {
            self.usernameAsyncValidationMessage = this.$t(
              'validations.messages.repeated_server_error',
              { fieldName: this.$t('register.username') }
            )
          })
      }
    },
      togglePassword()
      {
          this.isPasswordVisible ? this.isPasswordVisible = false : this.isPasswordVisible = true
          this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      }
  },
  mounted () {
    this.changeWindowSize()
    this.initializeForm()
    if(!this.isMaxWidth768()){
      this.inputType.cellOrEmailLabel = 'register.cell'
      this.inputType.cellOrEmailPlaceholder = 'register.cellPlaceholder'
    }
  }
}

</script>
